"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var msg = require("console-tags.js/src/console-tags.js");
var controllers_1 = require("./controllers");
var dispatch = /** @class */ (function () {
    function dispatch() {
    }
    dispatch.prototype.controllerAvaliable = function (controller) {
        if (controller === "0") {
            return false;
        }
        if (controller === "") {
            msg.warning("Dispatch", "Empty controller");
            return false;
        }
        if (typeof controllers_1.default[controller] === "undefined") {
            msg.error("Dispatch", '"' + controller + '"' + " is undefined");
            return false;
        }
        return true;
    };
    dispatch.prototype.init = function () {
        var _this = this;
        document.addEventListener("DOMContentLoaded", function () {
            var controller = document
                .querySelector("[controller]")
                .getAttribute("controller");
            if (_this.controllerAvaliable(controller)) {
                controllers_1.default[controller].default();
            }
        });
    };
    return dispatch;
}());
exports.default = new dispatch().init();
